export enum Role {
  superuser = 0,
  admin = 1,
  employee = 2,
  customer = 3,
}
